import { FormattedMessage } from "react-intl";
import styles from "./ExploreDeprecated.module.scss";
import { clsx } from "clsx";
import MiscellaneousProgress from "../../common/icons/MiscellaneousProgress.tsx";
import BaseLinkOrButton from "../../common/core-ui/BaseLinkOrButton.tsx";
import { useDownloadAppUrl } from "../../common/features/native/useDownloadAppUrl.ts";
import { useBrandLoaderData } from "../root/rootLoader.ts";

/**
 * Native apps link to this to indicate fraction explore has been deprecated
 */
export default function ExploreDeprecated() {
  const downloadAppUrl = useDownloadAppUrl();
  const brand = useBrandLoaderData();
  const appName = brand.DownloadOffline.appName;

  return (
    <div className={styles.container}>
      <div className={styles.iconContainer}>
        <MiscellaneousProgress className={styles.icon} />
      </div>
      <h1 className={styles.heading}>
        <FormattedMessage defaultMessage="Update Required" />
      </h1>
      <p>
        <FormattedMessage
          defaultMessage="We've upgraded Explore to a new experience. Update {appName} to the latest version to continue using it."
          values={{ appName }}
        />
      </p>
      <BaseLinkOrButton
        href={downloadAppUrl}
        className={clsx(
          "vst-button-pill",
          "vst-button-variant-outline",
          styles.updateButton
        )}
        target="_self"
      >
        <FormattedMessage defaultMessage="Update Now" />
      </BaseLinkOrButton>
      <p className={styles.hint}>
        <FormattedMessage defaultMessage="Already updated? Restart the app to see the latest version of Explore." />
      </p>
    </div>
  );
}
